const mapFlows = (flows: (string | number)[] | undefined): number[] => {
  if (flows && flows.every(Number)) return flows as number[];
  return [];
};

export default mapFlows;
